import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { LinkService } from './link.service';

@Injectable({
  providedIn: 'root'
})
export class BackService implements OnInit, OnDestroy {

  constructor(
    private location: Location,
    private router: Router,
    private linkService: LinkService,
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  goBack() {
    if (this.router.navigated) {
      this.location.back();
    } else {
      this.linkService.goMainPage();
    }
  }

}
